export default "__VITE_ASSET__16ee7865__"